$(document).ready(function () {
  const $mySlider_images = $(".mySlider_images img");
  const $mySlider_bullets = $(".mySlider_bullets");
  const $mySlider_imageWrapper = $(".mySlider_images");
  const $mySlider_thumbnails = $(".mySlider_thumbnails .thumbnailBtn"); // NEW
  let mySlider_currentIndex = 0;
  const mySlider_interval = 5000;

  // Setup bullets
  $mySlider_images.each(function (index) {
    $mySlider_bullets.append(
      `<span data-mySlider-index="${index}" class="${
        index === 0 ? "active" : ""
      }"></span>`
    );
  });

  // Update function
  const mySlider_update = (index) => {
    mySlider_currentIndex =
      (index + $mySlider_images.length) % $mySlider_images.length;
    $mySlider_imageWrapper.css(
      "transform",
      `translateX(-${mySlider_currentIndex * 100}%)`
    );

    $mySlider_bullets
      .children()
      .removeClass("active")
      .eq(mySlider_currentIndex)
      .addClass("active");

    // Highlight current thumbnail
    $mySlider_thumbnails.removeClass("active");
    $mySlider_thumbnails.eq(mySlider_currentIndex).addClass("active"); // NEW
  };

  // Autoplay
  let mySlider_autoplay = setInterval(
    () => mySlider_update(mySlider_currentIndex + 1),
    mySlider_interval
  );

  // Navigation
  $(".mySlider_prev").click(() => {
    clearInterval(mySlider_autoplay);
    mySlider_update(mySlider_currentIndex - 1);
    mySlider_autoplay = setInterval(
      () => mySlider_update(mySlider_currentIndex + 1),
      mySlider_interval
    );
  });

  $(".mySlider_next").click(() => {
    clearInterval(mySlider_autoplay);
    mySlider_update(mySlider_currentIndex + 1);
    mySlider_autoplay = setInterval(
      () => mySlider_update(mySlider_currentIndex + 1),
      mySlider_interval
    );
  });

  // Bullet click
  $mySlider_bullets.on("click", "span", function () {
    const index = $(this).data("myslider-index");
    clearInterval(mySlider_autoplay);
    mySlider_update(index);
    mySlider_autoplay = setInterval(
      () => mySlider_update(mySlider_currentIndex + 1),
      mySlider_interval
    );
  });

  // Thumbnail click – NEW
  $mySlider_thumbnails.on("click", function () {
    $(".video-thumbnail-wrapper").hide();
    const index = $(this).data("index");
    clearInterval(mySlider_autoplay);
    mySlider_update(index);
    mySlider_autoplay = setInterval(
      () => mySlider_update(mySlider_currentIndex + 1),
      mySlider_interval
    );
  });

  $(".custom-increment").click(function () {
    let value = parseInt($(".custom-quantity").val());
    $(".custom-quantity, #Quantity").val(value + 1);
  });

  $(".custom-decrement").click(function () {
    let value = parseInt($(".custom-quantity").val());
    if (value > 1) {
      $(".custom-quantity, #Quantity").val(value - 1);
    }
  });

  /*document.querySelectorAll(".accordion-button").forEach((button) => {
    button.addEventListener("click", function () {
      document.querySelectorAll(".accordion-button").forEach((btn) => {
        const icon = btn.querySelector(".icon");
        icon.textContent = btn.classList.contains("collapsed") ? "+" : "-";
      });
    });
  });

  const deviceComparo = document.getElementById("deviceComparo1");
  const scrollbarThumb = document.querySelector(".custom-scrollbar-thumb");

  function updateScrollbar() {
    const scrollWidth = deviceComparo.scrollWidth - deviceComparo.clientWidth;
    const scrollLeft = deviceComparo.scrollLeft;
    const thumbWidth = (scrollLeft / scrollWidth) * 100;

    // Ensure the thumb is always visible, even at the initial position
    scrollbarThumb.style.width = `${Math.max(thumbWidth, 50)}%`;
  }

  // Initialize the scrollbar thumb
  updateScrollbar();

  deviceComparo.addEventListener("scroll", updateScrollbar);*/

  $(".accordion-button").on("click", function () {
    $(".accordion-button").each(function () {
      const icon = $(this).find(".icon");
      icon.text($(this).hasClass("collapsed") ? "+" : "-");
    });
  });

  const $deviceComparo = $("#deviceComparo1");
  const $scrollbarThumb = $(".custom-scrollbar-thumb");

  function updateScrollbar() {
    const scrollWidth =
      $deviceComparo[0].scrollWidth - $deviceComparo[0].clientWidth;
    const scrollLeft = $deviceComparo.scrollLeft();
    const thumbWidth = (scrollLeft / scrollWidth) * 100;

    // Ensure the thumb is always visible, even at the initial position
    $scrollbarThumb.css("width", `${Math.max(thumbWidth, 50)}%`);
  }

  // Initialize the scrollbar thumb
  updateScrollbar();

  $deviceComparo.on("scroll", updateScrollbar);
});

// Tooltip
$(document).ready(function () {
  const jsonData = {
    "autoReLink-icon":
      "Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.",
    "codePriority-icon":
      "Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.",
    "driveCycleProcedures-icon":
      "Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.",
    "bidirectionalSystemTest-icon":
      "Bidirectional System Tests let you control vehicle systems to identify issues. Common tests include actuator tests, EVAP system tests, injector balance tests, and solenoid tests.",
    "specialFunctionsRoutinesCalibrations-icon":
      "Special Functions refer to special reset features like SAS, DPF regen, EVAP VSV check, and more.",
    "all10ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "all8ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "secureGatewayForFCAvehicles-icon":
      "Secure Gateway access enables select scanners to unlock FCA vehicles' secure gateway by connecting through an AutoAuth account.",
    "batteryTooltip-unused": "Long-lasting battery life for extended usage.",
  };

  let activeTooltip = null;

  // Event delegation for dynamically added elements
  $("body").on("click", ".tooltipForComparo-trigger", function (e) {
    e.stopPropagation();

    // Close any existing tooltip
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }

    const $trigger = $(this);
    const uniqueClass = $trigger
      .attr("class")
      .split(" ")
      .find((cls) => jsonData[cls]);

    const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

    // Create the tooltip dynamically
    const $tooltip = $('<div class="tooltipForComparo"></div>').html(
      tooltipText
    );

    // Append tooltip to the body
    $("body").append($tooltip);

    // Position the tooltip
    const rect = $trigger[0].getBoundingClientRect();
    const left = rect.left + window.scrollX;
    const top = rect.top + window.scrollY - $tooltip.outerHeight() - 10;

    $tooltip.css({
      left: `${left}px`,
      top: `${top}px`,
      display: "block",
    });

    activeTooltip = $tooltip;
  });

  // Close tooltip on outside click
  $(document).on("click", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Close tooltip on scroll
  $("#deviceComparo1").on("scroll", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Handle tooltips inside Bootstrap modals
  $(document).on("shown.bs.modal", function (e) {
    const $modal = $(e.target);

    $modal.on("click", ".tooltipForComparo-trigger", function (e) {
      e.stopPropagation();

      // Close any existing tooltip
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      const $trigger = $(this);
      const uniqueClass = $trigger
        .attr("class")
        .split(" ")
        .find((cls) => jsonData[cls]);

      const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

      // Create the tooltip dynamically
      const $tooltip = $('<div class="tooltipForComparo"></div>').html(
        tooltipText
      );

      // Append tooltip to the modal
      $modal.append($tooltip);

      // Position the tooltip
      const rect = $trigger[0].getBoundingClientRect();
      const left = rect.left;
      const top = rect.top - $tooltip.outerHeight() - 10;

      $tooltip.css({
        left: `${left}px`,
        top: `${top}px`,
        display: "block",
      });

      activeTooltip = $tooltip;
    });

    // Close tooltip on scroll inside the modal
    $modal.on("scroll", function () {
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
    });
  });
});

// Desktop/laptop Nav #webflowNav
$(document).ready(function () {
  $("#mobileMenuButton").click(function () {
    $("#mobileNav").slideToggle();
  });

  $("#mobileNav a").click(function () {
    $("#mobileNav").slideToggle();
  });

  $(".heading-24").click(function () {
    window.scrollTo(0, 0);
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      //header.addClass("sticky");
    } else {
      //header.removeClass("sticky");
    }
  });

  $(window).trigger("scroll");

  // Add active class on click
  $(".nav-link-3.scrollToAnchorLink").on("click", function (event) {
    event.preventDefault();
    $(".nav-link-3").removeClass("active");
    $(this).addClass("active");

    var target = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  });

  $("#smallElfsightWidget").on("click", function (event) {
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#ProductReviews").offset().top,
      },
      500
    );
  });

  const $desktopLaptopNav = $("#shopify-section-header");

  /*function handleNavLinksScroll() {
    $(window).on("scroll.navLinks", function () {
      var scrollPos = $(window).scrollTop();

      $(".nav-link-3").each(function () {
        var href = $(this).attr("href");
        var target = $(href);

        var sectionOffset = target.offset().top - 100;

        if (scrollPos >= sectionOffset) {
          $(".nav-link-3").removeClass("active");
          $(this).addClass("active");
        }
      });
    });
  }*/

  function handleDesktopScrollVersion1() {
    $("#webflowNav").hide();
    $(window)
      .on("scroll.desktopNav", function () {
        if ($(this).scrollTop() >= 1200) {
          $desktopLaptopNav.addClass("hiddenDiv");
          $("#webflowNav").show();
        } else {
          $desktopLaptopNav.removeClass("hiddenDiv");
          $("#webflowNav").hide();
        }
      })
      .trigger("scroll");
  }

  function handleDesktopScroll() {
    $("#webflowNav").hide();
    $("#beacon-container").hide();

    $(window)
      .on("scroll.desktopNav", function () {
        const scrollTop = $(this).scrollTop();
        const windowHeight = $(this).height();
        const docHeight = $(document).height();

        // How close to the bottom before hiding (e.g., 100px)
        const bottomOffset = 500;

        if (scrollTop + windowHeight >= docHeight - bottomOffset) {
          // Near bottom → hide nav
          $("#webflowNav").hide();
          $("#beacon-container").show();
        } else if (scrollTop >= 1200) {
          // Mid scroll → show nav
          $desktopLaptopNav.addClass("hiddenDiv");
          $("#webflowNav").show();
          $("#beacon-container").hide();
        } else {
          // Top → hide nav again
          $desktopLaptopNav.removeClass("hiddenDiv");
          $("#webflowNav").hide();
          $("#beacon-container").show();
        }
      })
      .trigger("scroll");
  }

  function adjustVisibility() {
    if ($(window).width() <= 1024) {
      $desktopLaptopNav.addClass("hiddenDiv");
      $(window).off("scroll.desktopNav");
    } else {
      handleDesktopScroll();
    }
  }

  //adjustVisibility();
  handleDesktopScroll();
  //handleNavLinksScroll();

  //$(window).on("resize", adjustVisibility);
});

$(document).ready(function () {
  $(".myTabZone_tab")
    .first()
    .click(function () {
      $(".video-thumbnail-wrapper").hide();
    });

  $(".myTabZone_tab").click(function () {
    $(".myTabZone_tab").removeClass("is-active");
    $(this).addClass("is-active");

    $(".myTabZone_content").removeClass("is-visible");
    $($(this).data("mycontent")).addClass("is-visible");
  });

  $(".myTabZone_tab")
    .eq(1)
    .click(function () {
      $("#zoneContent_2 .openVideoModal1").eq(0).click();
    });

  $("#closeRS2appVideo").on("click", function () {
    /* const video = $("#appVideo")[0];
    video.pause();
    video.currentTime = 0;*/
    $("body").removeClass("no-scroll2");
    $("#videoModal1, #videoModal1background").hide();
    $("#videoPlayerWrapper2").empty();
    //$("#firstThumbnail").click();
  });

  let selectedVideo = {};

  $("a.openVideoModal1").click(function (e) {
    //$(".video-thumbnail-wrapper").show();
    $(".video-thumbnail-wrapper").css("display", "flex");
    e.preventDefault();

    selectedVideo = {
      type: $(this).data("type"),
      src: $(this).data("src").trim(),
    };

    const thumbnail = $(this).data("thumbnail");
    $("#imgVideoThumbnailPreview").attr("src", thumbnail).show();
  });

  $("#imgVideoThumbnailPreview").click(function () {
    const { type, src } = selectedVideo;
    let content = "";

    if (type === "youtube") {
      content = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${src}?autoplay=1" 
        frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      $("#videoPlayerWrapper2").addClass("youtube");
    } else if (type === "mp4") {
      content = '<video id="appVideo" width="600" controls></video>';
      $("#videoPlayerWrapper2").removeClass("youtube");

      setTimeout(() => {
        const video = document.getElementById("appVideo");
        video.muted = true;

        if (Hls.isSupported()) {
          const hls = new Hls();
          hls.loadSource(src);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => video.play());
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = src;
          video.addEventListener("loadedmetadata", () => video.play());
        } else {
          content = "This video cannot be played in your browser.";
        }
      }, 0);
    }

    $("#videoPlayerWrapper2").html(content);
    $("body").addClass("no-scroll2");
    $("#videoModal1, #videoModal1background").show();
  });
});

/*$(document).ready(function () {
  $(".mySlider_images div img").on("click", function () {
    $("#fullImageViewer_img").attr("src", $(this).attr("src"));
    //$("#fullImageViewer").fadeIn();
    $("#fullImageViewer").css("display", "flex");
  });

  $(".full-image-close").on("click", function () {
    $("#fullImageViewer").fadeOut();
  });
});
*/

$(document).ready(function () {
  const $sliderNavWrapper = $(".sliderNavWrapper");
  const $mySliderContainer = $(".mySlider_container");
  const $zoneContent1 = $("#zoneContent_1");

  const $mySliderContainerNext = $mySliderContainer.next();
  const $zoneContent1Next = $zoneContent1.next();

  const $productSlideshowContainer = $("#productSlideshowContainer");

  $(".mySlider_images div img").on("click", function () {
    $("#fullImageViewer_img").attr("src", $(this).attr("src"));
    $("#fullImageViewer")
      .css("display", "flex")
      .append($sliderNavWrapper, $mySliderContainer, $zoneContent1);
  });

  $(".full-image-close").on("click", function () {
    $("#fullImageViewer").fadeOut(function () {
      // Put .sliderNavWrapper as first child
      $productSlideshowContainer.prepend($sliderNavWrapper);

      // Restore others to original positions
      if ($mySliderContainerNext.length) {
        $mySliderContainer.insertBefore($mySliderContainerNext);
      } else {
        $mySliderContainerNext.parent().append($mySliderContainer);
      }

      if ($zoneContent1Next.length) {
        $zoneContent1.insertBefore($zoneContent1Next);
      } else {
        $zoneContent1Next.parent().append($zoneContent1);
      }
    });
  });
});

$(document).ready(function () {
  const $tabsContainer = $("#zoneContent_1 .mySlider_thumbnails");
  const $tabs = $("#zoneContent_1 .thumbnailBtn");
  const $leftArrow = $("#zoneContent_1 .scroll-arrow-buttons.left");
  const $rightArrow = $("#zoneContent_1 .scroll-arrow-buttons.right");

  // Scroll container by a fixed amount when arrows are clicked
  const scrollAmount = 200;

  // Update scroll button visibility
  function updateArrowVisibility() {
    const scrollLeft = $tabsContainer.scrollLeft();
    const maxScrollLeft =
      $tabsContainer[0].scrollWidth - $tabsContainer.width();

    $leftArrow.toggleClass("hidden", scrollLeft <= 0);
    $rightArrow.toggleClass("hidden", scrollLeft >= maxScrollLeft);
  }

  // Initialize visibility on load
  updateArrowVisibility();

  $leftArrow.on("click", function () {
    $tabsContainer.animate(
      { scrollLeft: $tabsContainer.scrollLeft() - scrollAmount },
      300,
      updateArrowVisibility
    );
  });

  $rightArrow.on("click", function () {
    $tabsContainer.animate(
      { scrollLeft: $tabsContainer.scrollLeft() + scrollAmount },
      300,
      updateArrowVisibility
    );
  });

  // Highlight clicked tab and update content
  $tabs.on("click", function () {
    $tabs.removeClass("active");
    $(this).addClass("active");

    const tabLeft = $(this).position().left + $tabsContainer.scrollLeft();
    const tabWidth = $(this).outerWidth();
    const containerWidth = $tabsContainer.width();

    // Center the clicked tab if possible
    const targetScrollLeft = tabLeft - containerWidth / 2 + tabWidth / 2;
    $tabsContainer.animate(
      { scrollLeft: targetScrollLeft },
      300,
      updateArrowVisibility
    );
  });

  // Update visibility on manual scroll
  $tabsContainer.on("scroll", updateArrowVisibility);
});

$(document).ready(function () {
  // Star Ratings
  const starFull = "https://innovas-cdn.filesplanet.xyz/images/one-star.svg";
  const starHalf = "https://innovas-cdn.filesplanet.xyz/images/half-star.svg";
  const starBlank = "https://innovas-cdn.filesplanet.xyz/images/half-star.svg";

  function buildStars(rating) {
    const full = Math.floor(rating);
    const half = rating % 1 === 0.5 ? 1 : 0;
    const empty = 5 - full - half;
    let html = "";
    for (let i = 0; i < full; i++)
      html += `<img src="${starFull}" style="width:24px;" alt="star">`;
    if (half)
      html += `<img src="${starHalf}" style="width:24px;" alt="half star">`;
    for (let i = 0; i < empty; i++)
      html += `<img src="${starBlank}" style="width:24px;" alt="blank star">`;
    return html;
  }

  function processStarRatings(targetSelector = ".detailsRow1") {
    $(`${targetSelector} :contains('generateStars(')`).each(function () {
      const html = $(this).html();
      const regex = /generateStars\((\d(?:\.5)?),\s*(\d+)\)/g;
      const newHTML = html.replace(regex, (_, rating, count) => {
        const countNum = parseInt(count, 10);
        return `
                <div class="stars" style="display:inline-block;">${buildStars(
                  parseFloat(rating)
                )}</div>
                <div class="review-count">${countNum.toLocaleString()}${
          countNum === 1 ? " review" : "+ reviews"
        }</div>
            `;
      });
      if (newHTML !== html) $(this).html(newHTML);
    });
  }

  function waitForStars(
    selector = ".detailsRow1",
    delay = 100,
    maxAttempts = 20
  ) {
    let attempts = 0;
    const interval = setInterval(() => {
      if ($(selector).length) {
        processStarRatings(selector);
        clearInterval(interval);
      } else if (++attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn("Star rating container not found.");
      }
    }, delay);
  }
  waitForStars(); // Wait and trigger on dynamically added .productImagesRow
});
